import Axios from "axios";
import LiAuth from "@/api-services/liauth.service";
import BaseService from "@/api-services/base.service";
const USUARIOS = `${BaseService.URL}/usuarios`;
const SESIONES = `${BaseService.URL}/sesiones`;
import Ubicaciones from "@/api-services/ubicaciones.service";

import SuscripcionesUsuarios from "@/api-services/suscripciones.usuarios.service";
import suscripcionesUsuariosService from "./suscripciones.usuarios.service";

export default {
  estaLogueado() {
    var Sesion = this.getSesion();
    return !(Sesion == null || Sesion == "");
  },
  getSesion() {
    return localStorage.sesion;
  },
  setSesion(Sesion) {
    localStorage.sesion = Sesion;
  },
  FotoUsuarioURL(Usuario) {
    var R = "img/theme/user512.png";
    //console.debug(Usuario);
    if (
      Usuario != undefined &&
      Usuario != null &&
      Usuario.urlFotoMiniatura != undefined &&
      Usuario.urlFotoMiniatura != null &&
      Usuario.urlFotoMiniatura != ""
    ) {
      R = Usuario.urlFotoMiniatura;
    }
    if (
      Usuario != undefined &&
      Usuario != null &&
      Usuario.UrlFotoMiniatura != undefined &&
      Usuario.UrlFotoMiniatura != null &&
      Usuario.UrlFotoMiniatura != ""
    ) {
      R = Usuario.UrlFotoMiniatura;
    }
    //console.debug(R);
    return R;
  },
  EsUsuarioActual(Usuario, OnFinalizado) {
    this.getPerfilLocal((PerfilLocal) => {
      /*console.debug(Usuario);
      console.debug(PerfilLocal.usuario);*/
      OnFinalizado(this.PerfilLocal.usuario.usuarioID == Usuario.usuarioID);
      //return ;
    });
  },
  ObtenUrlInvitacion(Reunion) {
    return (
      window.location.protocol +
      "//" +
      window.location.host +
      "/#/ri?i=" +
      Reunion.reunionAlternoID
    );
  },
  ObtenUrlEdicion(Reunion) {
    return (
      window.location.protocol +
      "//" +
      window.location.host +
      "/#/usuarios/edicion?i=" +
      Reunion.reunionAlternoID
    );
  },
  getUsuario(UsuarioID) {
    return Axios.get(USUARIOS + `/${UsuarioID}`, LiAuth.header());
  },
  getUsuarios() {
    return Axios.get(USUARIOS, LiAuth.header());
  },
  getPerfil() {
    return Axios.get(USUARIOS + `/Perfil?SoloBeta=${BaseService.EsBeta}`, LiAuth.header());
  },
  postUsuario(data) {
    /*
     *data {
     *         [Required]
      public string Nombre { get; set; }
      /// <summary>
      /// Numero teléfonico con código de pais
      /// </summary>
      [Required]
      public string Telefono { get; set; }
      /// <summary>
      /// Correo electrónico
      /// </summary>
      [Required]
      public string Correo { get; set; }
      /// <summary>
      /// contraseña del usuario
      /// </summary>
      [Required]
      public string Password { get; set; }
      public string Traking { get; set; }}
     *
     *
     * */
    return Axios.post(USUARIOS, data, LiAuth.header());
  },
  /*        /// <summary>
        /// Correo electrónico o Número Teléfonico
        /// </summary>
        public string CorreoTelefono { get; set; }
        /// <summary>
        /// Contraseña del usuario
        /// </summary>
        public string Password { get; set; }

        /// <summary>
        /// Datos opcionales para ser almacenados en la sesión
        /// </summary>
        public string Traking { get; set; }*/
  postSesion(data) {
    /*        /// <summary>
          /// Correo electrónico o Número Teléfonico
          /// </summary>
          public string CorreoTelefono { get; set; }
          /// <summary>
          /// Contraseña del usuario
          /// </summary>
          public string Password { get; set; }
  
          /// <summary>
          /// Datos opcionales para ser almacenados en la sesión
          /// </summary>
          public string Traking { get; set; }*/
    return Axios.post(SESIONES, data, LiAuth.header());
  },
  cerrarSesion() {
    // return;
    localStorage.removeItem("sesion");
    localStorage.removeItem("perfilLocal");
    localStorage.removeItem("suscripcionID");
    localStorage.removeItem("referencia");
    //La prueba de identidad de la NOM-035 es de quien inició sesión, no del navegador:
    //ver src/api-services/nom035stps2018.acceso.service.js.
    localStorage.removeItem("nom035Acceso");
    this.PerfilLocal = null;  // Limpiar también la memoria
  },
  PerfilLocal: null,
  /*
   * Valida que el perfil traiga la forma mínima que esperan las vistas.
   * Las vistas usan Perfil.usuario.* de inmediato, así que un perfil sin
   * usuario las hace fallar y deja su spinner encendido.
   * */
  EsPerfilValido(Perfil) {
    return Perfil != null && Perfil.usuario != null;
  },
  /*
   * Obtiene el perfil del usuario.
   * Finalizado: recibe el perfil. Recibe null si el API falló y no se pasó OnError.
   * Actualiza: fuerza la relectura desde el API ignorando la caché.
   * OnError: opcional, recibe (error, Status) cuando el API falla.
   * */
  getPerfilLocal(Finalizado, Actualiza, OnError) {
    if (this.PerfilLocal != null && Actualiza != true) {
      Finalizado(this.PerfilLocal);
      return;
    }
    if (this.PerfilLocal == null && Actualiza != true) {
      var Ls = localStorage.perfilLocal;
      if (Ls != null && Ls != "") {
        try {
          var Cache = JSON.parse(Ls);
          //Un perfil incompleto en caché haría fallar a las vistas, se descarta
          if (!this.EsPerfilValido(Cache)) throw new Error("perfilLocal incompleto");
          this.PerfilLocal = Cache;
          suscripcionesUsuariosService.setSuscripcionesUsuario(
            this.PerfilLocal.usuario.suscripcionesUsuario
          );
          Finalizado(this.PerfilLocal);
          return;  // Evitar llamadas múltiples al callback
        } catch (e) {
          console.error("Error parsing perfilLocal:", e);
          this.PerfilLocal = null;
          localStorage.removeItem("perfilLocal");
        }
      }
    }
    this.getPerfil()
      .then((response) => {
        this.PerfilLocal = response.data;
        localStorage.perfilLocal = JSON.stringify(this.PerfilLocal);
        suscripcionesUsuariosService.setSuscripcionesUsuario(
          this.PerfilLocal.usuario.suscripcionesUsuario
        );
        Finalizado(this.PerfilLocal);
      })
      .catch((error) => {
        this.PerfilLocal = null;
        console.error(error);
        var Status = error && error.response ? error.response.status : 0;
        //La sesión ya no sirve, no hay nada que reintentar con ella
        if (Status == 401 || Status == 403) this.cerrarSesion();
        /* Siempre hay que avisar: si nadie recibe el error la vista se queda
           con su spinner encendido indefinidamente. */
        try {
          if (typeof OnError === "function") OnError(error, Status);
          else Finalizado(null);
        } catch (e) {
          console.error(e);
        }
      });
  },
  ///TimeO
  getPerfilSoloLocal(Evento, TimeOutMiliSegundos, Intentos) {
    if (TimeOutMiliSegundos == null) TimeOutMiliSegundos = 1000;
    //Sin límite el reintento es infinito cuando el perfil nunca llega
    if (Intentos == null) Intentos = 30;
    var Yo = this;
    if (this.PerfilLocal == null) {
      if (Intentos <= 0) {
        Evento(null);
        return;
      }
      setTimeout(function () {
        Yo.getPerfilSoloLocal(Evento, TimeOutMiliSegundos, Intentos - 1);
      }, TimeOutMiliSegundos);
      return;
    }
    Evento(this.PerfilLocal);
  },
  put(Datos) {
    /*
     * Datos Posibles
     *   "nombre": "string",
     *   "correo": "string",
     *   "telefono": "string",
     *   "rfu": "string",
     *   "correoValidado": true,
     *   "telefonoValidado": true,
     *   "passwordAnterior": "string",
     *   "passwordNuevo": "string"*/

    return Axios.put(`${USUARIOS}`, Datos, LiAuth.header());
  },
  delete() {
    return Axios.delete(
      `${USUARIOS}/${this.PerfilLocal.usuario.usuarioID}`,
      LiAuth.header()
    );
  },
  deleteSuscripcion(UsuarioID, SuscripcionID) {
    return Axios.delete(
      `${USUARIOS}/${UsuarioID}/Suscripciones/${SuscripcionID}`,
      LiAuth.header()
    );
  },

  ValidacionPost(Datos) {
    /*
     * Datos = {nombre:"",correo:"",telefono:""}
     * */
    return Axios.post(`${USUARIOS}/Validacion`, Datos, LiAuth.header());
  },
  ValidacionPut(Datos) {
    /*
     *Datos = {verificacionID:"",codigo:""}
     * verificacionID correo o telefono a validar
     * codigo de validación
     * */
    return Axios.put(`${USUARIOS}/Validacion`, Datos, LiAuth.header());
  },
  /*
   *Envia un correo o SMS con el código de recuperación
   * */
  GetRecuperarPassword(CorreoOTelefono) {
    return Axios.get(
      `${USUARIOS}/${CorreoOTelefono}/RecuperarPassword`,
      LiAuth.header()
    );
  },
  SuplantarPatch(Correo) {
    return Axios.patch(
      `${USUARIOS}/Suplantar`,
      { correo: Correo },
      LiAuth.header()
    );
  },

  /*  FotoPatch(Vista,  Orden, Archivo, OnUploadProgress, OnCorrecto, OnErroneo, OnFinalizado) {
    let formData = new FormData();
    formData.append('Foto', Archivo);
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Foto?Orden=${Orden}`);
    return Base.patch(Vista, URL, formData, {

      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: OnUploadProgress
    }, OnCorrecto, OnErroneo, OnFinalizado);
  },*/
};
